import React from "react";
import { Link } from "react-router-dom";
import logo from "./../../assets/logo.svg";
import { services } from "../../data/services";
import { SITE } from "../../data/site";
import Icon from "../UI/Icon";

const companyLinks = [
  { to: "/carpentry-services", label: "Carpentry Services" },
  { to: "/site-carpentry", label: "Site Carpentry" },
  { to: "/areas", label: "Areas We Cover" },
  { to: "/our-work", label: "Our Work" },
  { to: "/about-us", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-paper">
      <div className="max-w-site mx-auto px-5 sm:px-10 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3">
              <img src={logo} alt="" className="w-12" />
              <span className="font-display text-2xl font-semibold">Cambridge Carpenter</span>
            </div>
            <p className="text-paper/70 leading-7 mt-5 max-w-sm">
              Bespoke carpentry and joinery for homes and gardens across Cambridge and Cambridgeshire.
              Design-led, fully insured and finished with care.
            </p>
            <div className="flex flex-wrap gap-3 mt-6">
              <Link to="/contact" className="btn-primary !py-2.5 !px-5 text-xs">Free Quote</Link>
              <a href={SITE.phoneHref} className="btn-outline-light !py-2.5 !px-5 text-xs">Call us</a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h2 className="font-display text-lg font-semibold mb-4">Services</h2>
            <ul className="space-y-2.5 text-paper/70">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/carpentry-services/${s.slug}`} className="hover:text-brass transition-colors">
                    {s.navLabel}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h2 className="font-display text-lg font-semibold mb-4">Company</h2>
            <ul className="space-y-2.5 text-paper/70">
              {companyLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-brass transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact / NAP */}
          <div>
            <h2 className="font-display text-lg font-semibold mb-4">Get in touch</h2>
            <ul className="space-y-4 text-paper/70">
              <li className="flex items-start gap-3">
                <Icon name="pin" className="w-5 h-5 text-brass shrink-0 mt-0.5" />
                <span>
                  {SITE.address.street}
                  <br />
                  {SITE.address.town}, {SITE.address.postcode}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Icon name="phone" className="w-5 h-5 text-brass shrink-0" />
                <a href={SITE.phoneHref} className="hover:text-brass transition-colors">{SITE.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Icon name="mail" className="w-5 h-5 text-brass shrink-0" />
                <a href={`mailto:${SITE.email}`} className="hover:text-brass transition-colors break-all">
                  {SITE.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-3 border-t border-white/10 text-paper/50 text-sm pt-6 mt-14">
          <span>© {year} Cambridge Carpenter. All rights reserved.</span>
          <span className="flex flex-wrap gap-x-2 gap-y-1">
            <span>Carpentry &amp; joinery in Cambridge, Cambridgeshire.</span>
            <span>
              Website by{" "}
              <a
                href="https://ec-web.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brass transition-colors"
              >
                EC Web
              </a>
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
